import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Chatserver from '../entities/user';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface ChatserverState extends ListState<Chatserver> {
    editChatserver: Chatserver;
    chatstatus:boolean;
    _chatHub:any;
    _chatIndexHub:any;
    _chatServerHub:any;
}
class ChatserverModule extends ListModule<ChatserverState, any, Chatserver> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Chatserver>(),
        loading: false,
        editChatserver: new Chatserver(),
        chatstatus:false,
        _chatHub:{},
        _chatIndexHub:{},
        _chatServerHub:{},
    };
    public actions = {
        async getchatindex(context: ActionContext<ChatserverState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/CustomChat/GetChatIndex');
            return reponse.data.result;
        },
        async getchatserver(context: ActionContext<ChatserverState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/CustomChat/GetChatServer', {params: payload.data});
            return reponse.data.result;
        },
        async getnewchatsalemanlog(context: ActionContext<ChatserverState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/CustomChat/GetNewChatSaleManLog', {params: payload.data});
            return reponse.data.result;
        },
    };
    public mutations = {
        setCurrentPage(state: ChatserverState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ChatserverState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: ChatserverState, Chatserver: Chatserver) {
            state.editChatserver = Chatserver;
        },
        setChatstatus(state: ChatserverState, data) {
            state.chatstatus = data;
        },
        setChatHub(state: ChatserverState, data) {
            state._chatHub = data;
        },
        setChatIndexHub(state: ChatserverState, data) {
            state._chatIndexHub = data;
        },
        setChatServerHub(state: ChatserverState, data) {
            state._chatServerHub = data;
        },
    };
}
const chatserverModule = new ChatserverModule();
export default chatserverModule;
